module.exports = __webpack_public_path__ + "img/pp_logo.0146ed66.jpg";